export const ID = ':id'
export const PROFILE = 'profile'

export const getRouteWithParams = (
  route: string,
  params: Record<string, string | undefined>
) => {
  let result = route

  Object.keys(params).forEach((key) => {
    if (params[key] === undefined) {
      // eslint-disable-next-line no-console
      console.error(`key: ${key} is undefined (getRouteWithParams)`)
    }

    result = result.replace(`:${key}`, params[key] || '')
  })

  return result
}
